import * as React from "react";
import {useEffect, useState} from "react";
import ImageComponent from "./ImageComponent";
import {populateImageUrl} from "../service/ImageService";


export default function AdhocImageGallary(props) {
    const {images, setImages, isReadOnly} = props

    const [isLoading, setIsLoading] = useState(false)

    // Function to delete an image by id
    const deleteImage = (id) => {
        // Filter out the image with the specific id
        const updatedImages = images.filter(image => image.id !== id);
        // Update the state with the new array of images
        setImages(updatedImages);
    };

    const imageSize = 100

    return (
        <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '10px',
            justifyContent: 'center', // This centers the items horizontally
            alignItems: 'center', // This centers the items vertically in their line
            alignContent: 'center' // This centers the flex lines themselves within the container
        }}>
            {isLoading && <div>Loading Images... <img width={"100px"} src={"/loading.gif"}/></div>}

            {images && images.map((item, index) => (
                <ImageComponent
                    key={index + item.id}
                    isReadOnly={false}
                    item={item}
                    alt={item.title}
                    loading="lazy"
                    width={imageSize}
                    height={imageSize}
                    isReadOnly={isReadOnly}
                    deleteImage={deleteImage}
                />

            ))}
        </div>

    )
}
